<div
  class="container min-vh-100 d-flex align-items-center justify-content-center"
>
  <div class="row w-100">
    <div class="col-md-6 offset-md-3 col-lg-5 offset-lg-3">
      <div class="access-card p-5 text-center">
        <div class="icon-wrapper mb-4">
          <svg
            class="lock-svg"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 10V7C6 4.23858 8.23858 2 11 2C13.7614 2 16 4.23858 16 7V10"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <rect
              x="4"
              y="10"
              width="14"
              height="12"
              rx="3"
              stroke-width="1.8"
            />
            <path
              d="M11 14V18"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div class="mb-3">
          <span class="pill">ACCESS PENDING</span>
        </div>

        <h3 class="title mb-3">Waiting for permissions</h3>

        <p class="text-muted mb-4" style="max-width: 420px; margin: 0 auto">
          Your account is active, but no roles have been assigned yet. Once an
          administrator grants access, your dashboard will become available
          automatically.
        </p>

        <div class="d-flex justify-content-center gap-3">
          <p-button label="Logout" icon="pi pi-sign-out" (onClick)="logout()" />
        </div>
      </div>
    </div>
  </div>
</div>
